import React from 'react'
import * as SM from 'simple-markdown'
import { Link } from '~/models'
import { LinkTappable } from '~/ui/app/navigation'
import renderWidget, { parseWidgetParams, WIDGET_REGEXP } from '~/ui/app/widgets'
import { configure, LinkNode, WidgetNode } from '~/ui/components/markdown'

configure({
  extraRules: {
    link: {
      react: (node: SM.SingleASTNode, output: SM.Output<any>, state: SM.State) => {
        const content = output(node.content, state)
        const link    = getLinkFromNode(node as LinkNode)

        return React.createElement(LinkTappable, {
          children: content,
          link:     link,
          style:    {display: 'inline-flex'},
        })
      },
    },

    widget: {
      order: SM.defaultRules.link.order - 1,

      match: (source: string) => WIDGET_REGEXP.exec(source),

      parse: (capture: SM.Capture, parse: any, state: SM.State) => {
        return {
          type:   'widget',
          widget: capture[1],
          params: parseWidgetParams(capture[2]),
        }
      },

      react: (node: SM.SingleASTNode, output: any, state: SM.State) => {
        const {widget, params} = node as WidgetNode
        return React.createElement(React.Fragment, {
          key: state.key,
        }, renderWidget(widget, params))
      },
    },
  },
})

/**
 * Extracts a Link from a LinkNode. We use a little trick here, because Markdown supports setting a title
 * attribute like so: `[<caption>](<url> "<title>"). We don't use the title, because we're ok using the
 * caption, so we repurpose the title attribute as a way to setting the {@link Link.target} of the link.
 *
 * @param node The node.
 * @returns The parsed link.
 */
export function getLinkFromNode(node: LinkNode): Link {
  return {href: node.target, target: node.title}
}